// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination--pagination"};